import React, { useState, useRef, Fragment } from 'react'
import PropTypes from 'prop-types'
import GgGolfHubPopup from '../../../gg_golf_hub/components/shared/gg_golf_hub_popup'
import { GGButton } from '../../../shared/new_components/GGButton'
import { GGInput } from '../../../shared/new_components/GGInput'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Loader from 'react-loader-spinner'

export const GolfHubAddSponsorsPopup = (props) => {
  const [ imagePreview, setImagePreview ] = useState({image: ''})
  const [ disableImageSave, sedDisableImageSave ] = useState(true)
  const inputRef = useRef(null)

  const handleClick = (e) => {
    e.preventDefault()
    inputRef.current?.click()
  }

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    setImagePreview({image: URL.createObjectURL(file), imageFile: file, url: ''})

    let message = ''
    if (file.size > 6000000) { // bytes
      message = window.I18n.t('views.golfhub.upload_errors.file_too_large')
    }

    if ([ 'image/jpeg', 'image/png', 'image/gif', 'image/bmp' ].indexOf(file.type) < 0) {
      message += window.I18n.t('views.golfhub.upload_errors.invalid_format')
    }

    if (message !== '') {
      $('.error-message').removeClass('hidden')
      $('.error-message').html(message)
      sedDisableImageSave(true)

    } else {
      $('.error-message').addClass('hidden').disabled = false
      sedDisableImageSave(false)
    }
  }

  const handleModalClose = () => {
    props.setModalOpen(false)
    setImagePreview({ image: '' })
  }

  const saveImage = () => {
    props.setImages([ ...props.images, imagePreview ])
    handleModalClose()
  }

  return (
    <GgGolfHubPopup
      isOpen={props.modalOpen}
      title={window.I18n.t('views.golfhub.add_sponsors_logo')}
      onClose={handleModalClose}
      onConfirm={saveImage}
      isConfirmDisabled={!imagePreview.image || disableImageSave}
      confirmText={window.I18n.t('views.golfhub.modal.save')}
      >
      <div className='photo-upload'>
        <div className='photo-upload-content'>
          <div className='photo-upload-preview'>
            {imagePreview.image ? (
              <img
                src={imagePreview.image}
                alt={window.I18n.t('views.golfhub.photo_preview_alt')}
                className='photo-upload-image-uploaded'
              />
            ) : (
              <i className='fa-regular fa-image photo-upload-placeholder-icon' aria-hidden='true' />
            )}
          </div>
          <div className='photo-upload-action'>
            <GGButton onClick={(e) => handleClick(e)} label={window.I18n.t('views.golfhub.upload_crop_image.upload_photo')} />
            <input
              className='photo-upload-input'
              ref={inputRef}
              name='sponsor_file_from_popup'
              type='file'
              accept='image/jpeg, image/png, image/gif, image/bmp'
              onChange={(e) => handleImageUpload(e)}
            />
          </div>
        </div>
        <div className='photo-upload-hint'>
          <div>{window.I18n.t('views.golfhub.accepted_photo_formats')}</div>
          <div>{window.I18n.t('views.golfhub.sponsor_acceptable_format')}</div>
        </div>
        <div className='error-message btsp_alert_notices hidden add-margin-bottom-10 add-padding-all-5' />
        <div className='preview-container'>
          <img src={imagePreview.image} />
        </div>
      </div>
    </GgGolfHubPopup>
  )
}

export const GolfHubSponsorItems = ({images, setImages, deleted, setDeleted, setModalOpen, showLoading}) => {
  const swapImages = (result) => {
    const tempArr = [ ...images ]
    const tempVar = tempArr[ result.source.index ]
    tempArr.splice(result.source.index, 1)
    tempArr.splice(result.destination.index, 0, tempVar)

    setImages(tempArr)
  }

  const removeImage = (index) => {
    const tempArr = [ ...images ]
    setDeleted([ ...deleted, tempArr.splice(index, 1)[0]?.id ])
    setImages(tempArr)
  }

  const handleImgData = (value, index) => {
    const tempArr = [ ...images ]
    tempArr[index].url = value
    setImages(tempArr)
  }

  return (
    <Fragment>
      {images.length > 0 && (
        <DragDropContext onDragEnd={swapImages}>
          <Droppable droppableId="droppable">
          {(provided) => (
            <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className='img-container'>

              {images.map((img, i) => (
                <Draggable key={'draggable-' + i} draggableId={'draggable-' + i} index={i} >
                  {(prov) => (
                    <div
                      className='schedule-sponsor-draggable-container'
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      {...prov.dragHandleProps}>
                      <i className='fa-regular fa-grip-lines drag-handle-icon add-margin-right-15' aria-hidden='true' />
                      <img className='sponsor-preview' src={img.image} key={i}/>
                      {showLoading === true && (
                        <span className="span pull-right glg-loading-spinner sponsor-loading">
                          <Loader type="Oval" color={ '#0088CE' } height={ 20 } width={ 30 }></Loader>
                        </span>
                      )}
                      <div className='input_item_div'>
                        <GGInput
                          name='sponsor_urls[]'
                          placeholder={window.I18n.t('views.golfhub.sponsor_url')}
                          value={img.url}
                          onChange={(value) => handleImgData(value, i)}
                        />
                      </div>
                      <div
                        className='sponsor-remove-btn add-margin-left-10'
                        onClick={() => removeImage(i)}
                      >
                        <i className='fa-regular fa-trash-can' aria-hidden='true' />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
          </Droppable>
        </DragDropContext>
      )}
      <div className='upload-image add-margin-top-25' onClick={() => setModalOpen(true)}>
        {window.I18n.t('views.golfhub.add_sponsor')}
      </div>
    </Fragment>
  )
}

GolfHubSponsorItems.propTypes = {
  setModalOpen: PropTypes.func,
  setImages: PropTypes.func,
  setDeleted: PropTypes.func,
  images: PropTypes.array,
  deleted: PropTypes.array,
  showLoading: PropTypes.bool,
}

GolfHubAddSponsorsPopup.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  images: PropTypes.array,
  setImages: PropTypes.func,
}
